import { TableSortLabel } from '@mui/material';

import HeadTableCell from './HeadTableCell';
import { SORT_DIRECTIONS } from '../../../utils/tableSortDirections';

const getSortLabelSx = (isRightAligned) => ({
  color: 'inherit',
  flexDirection: isRightAligned ? 'row-reverse' : 'row',
  '&:hover, &:focus, &.Mui-active': { color: 'inherit' },
  '& .MuiTableSortLabel-icon': { color: 'inherit !important', opacity: 0.35 },
  '&:hover .MuiTableSortLabel-icon': { opacity: 0.7 },
  '&.Mui-active .MuiTableSortLabel-icon': { opacity: 1 },
});

/**
 * Encabezado de tabla ordenable: clic ascendente, otro clic descendente y otro clic sin orden.
 * Sin `onSort` o `sortKey` se comporta como un `HeadTableCell` común.
 * @param {Object} props
 * @param {string} [props.sortKey] Clave de la columna que se envía al ordenar.
 * @param {{key: string, direction: string}|null} [props.sort] Orden vigente de la tabla.
 * @param {Function} [props.onSort] Recibe la clave de la columna clickeada.
 * @param {Object} [props.sx] Estilos; con `textAlign: 'right'` la flecha va a la izquierda.
 * @param {React.ReactNode} props.children Título de la columna.
 * @returns {JSX.Element}
 */
const SortableHeadTableCell = ({ sortKey, sort, onSort, sx = {}, children, ...props }) => {
  if (!onSort || !sortKey) {
    return (
      <HeadTableCell sx={sx} {...props}>
        {children}
      </HeadTableCell>
    );
  }

  const isActive = sort?.key === sortKey;

  return (
    <HeadTableCell sx={sx} sortDirection={isActive ? sort.direction : false} {...props}>
      <TableSortLabel
        active={isActive}
        direction={isActive ? sort.direction : SORT_DIRECTIONS.asc}
        onClick={() => onSort(sortKey)}
        sx={getSortLabelSx(sx.textAlign === 'right')}
      >
        {children}
      </TableSortLabel>
    </HeadTableCell>
  );
};

export default SortableHeadTableCell;
